<div class="layout-main">
  <div class="container-fluid">
    <div *roles="['ROLE_CLIENT']" class="mb-3">
      You don't have the required permission to access this page.
    </div>
    <div *roles="['ROLE_MCKAY']">
      <div class="pb-2 mb-3 border-bottom">
        <h2>
          <b>Document Download Log</b>
        </h2>
      </div>
      <div class="d-flex flex-wrap">
      </div>
      <p-panel [toggleable]="true">
        <ng-template pTemplate="header">
          <span class="filter-title p-panel-title"><i class="fa fa-search"></i>Filter</span>
        </ng-template>
        <div class="row">
          <div class="form-group col-2">
            <p-floatLabel>
              <input [(ngModel)]="downloadLogFilterCriteria.documentNameOrTitle" (ngModelChange)="filter()"
                     class="form-control" id="document_name_and_title_filter" pInputText type="text"/>
              <label for="document_name_and_title_filter">Document name or title</label>
            </p-floatLabel>
          </div>
          <div class="form-group col-2">
            <p-floatLabel>
              <input [(ngModel)]="downloadLogFilterCriteria.fullNameOrEmail" (ngModelChange)="filter()"
                     class="form-control" id="full_name_and_email_filter" pInputText type="text"/>
              <label for="full_name_and_email_filter">User name or email</label>
            </p-floatLabel>
          </div>
          <div class="form-group col-2">
            <p-floatLabel>
              <p-dropdown [(ngModel)]="downloadLogFilterCriteria.companyName"
                          (onChange)="filter()"
                          [filter]="true"
                          [options]="companyList"
                          [showClear]="true"
                          placeholder="ALL">
              </p-dropdown>
              <label>Company</label>
            </p-floatLabel>
          </div>
          <div class="form-group col-2">
            <p-floatLabel>
              <p-calendar [(ngModel)]="downloadLogFilterCriteria.dateFrom" (onSelect)="filter()"
                          [showIcon]="true" dataType="string" dateFormat="mm/dd/yy">
              </p-calendar>
              <label>Creation Date From</label>
            </p-floatLabel>
          </div>
          <div class="form-group col-2">
            <p-floatLabel>
              <p-calendar [(ngModel)]="downloadLogFilterCriteria.dateTo" (onSelect)="filter()"
                          [showIcon]="true" dataType="string" dateFormat="mm/dd/yy">
              </p-calendar>
              <label>Creation Date To</label>
            </p-floatLabel>
          </div>
          <div class="col-2 p-float-label">
            <div class="row">
              <div class="ml-auto mt-auto buttons-margin-left">
                <div class="d-flex mt-2">
                  <div class="mr-2">
                    <button (click)="resetTable()" icon="fa fa-refresh pr-2" iconPos="left" label="Reset" pButton
                            type="button"></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-panel>

      <div class="row mt-3">
        <div class="col-12">
          <p-table #dt (sortFunction)="tableService.customSort($event)" [columns]="cols" [customSort]="true"
                   [first]="firstPage" [paginator]="true" [rowHover]="true" [rows]="30"
                   [tableStyle]="{'table-layout':'auto'}" [value]="filteredDownloadsList"
                   exportFilename="{{getFilename()}}"
                   id="downLoaded-documents-list-table">
            <ng-template pTemplate="caption">
              <div class="p-helper-clearfix caption-buttons-container">
                <button (click)="dt.exportCSV()" icon="fa fa-download pr-2" iconPos="left" id="reset_button"
                        label="Download csv"
                        pButton style="float:right; margin-left: 10px" type="button"></button>
              </div>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of cols" [pSortableColumnDisabled]="col.sortable"
                    [pSortableColumn]="col.field"
                    class="p-sortable-column ng-star-inserted">
                  {{ col.header }}
                  <p-sortIcon *ngIf="!col.sortable" [field]="col.field"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template let-document pTemplate="body">
              <tr [pSelectableRow]="document">
                <td>
                  {{ document.downloadDate | date : 'MMM d, y H:mm' }}
                </td>
                <td>
                  {{ document.documentName }}
                </td>
                <td>
                  {{ document.documentTitle }}
                </td>
                <td>
                  {{ getUserName(document) }}
                </td>
                <td>
                  {{ getUserCompanyName(document) }}
                </td>
                <td>
                  {{ getUserEmail(document) }}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="summary">
              {{ records }} results
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>
